import { Box, BoxProps, useTheme } from '@mui/material';

import { mergeSxProps } from '~/utils/helpers/sxProps';

export const OrgUnitSectionWrapper = (props: BoxProps) => {
  const { children, sx, ...boxProps } = props;

  const theme = useTheme();

  return (
    <Box
      {...boxProps}
      sx={mergeSxProps(
        {
          padding: theme.spacing(1),
          margin: theme.spacing(-1),
          borderRadius: theme.spacing(1.5),
          backgroundColor: '#fafafa',
          '& .MuiInputBase-root': {
            backgroundColor: theme.palette.background.default,
          },
        },
        sx,
      )}
    >
      {children}
    </Box>
  );
};
